@if (showSpeichernButton) {
  @if (!showSpeichernUndSchliessenOnly) {
    <button
      rippleEffect
      type="button"
      class="btn-mobile-group btn-primary"
      (click)="onSubmit.emit(false)"
      [ngbTooltip]="speichernText ? null : 'Speichern'">
      @if (speichernText) {
        {{ speichernText }}
      } @else {
        <love-it-generic-icon
          selector="save"
          class="hide-mobile" />
        <div class="hide-desktop">Speichern</div>
      }
    </button>
  }
  <button
    rippleEffect
    type="button"
    class="btn-mobile-group btn-primary"
    (click)="onSubmit.emit(true)"
    [ngbTooltip]="speichernText ? null : 'Speichern & schließen'">
    @if (speichernSchliessenText) {
      {{ speichernSchliessenText }}
    } @else {
      <love-it-generic-icon
        selector="bi-save"
        class="hide-mobile" />
      <div class="hide-desktop">Speichern & schließen</div>
    }
  </button>
}
<button
  rippleEffect
  type="button"
  class="btn-mobile-group btn-outline-secondary"
  (click)="closeModal()">
  {{ dirty ? "Abbrechen" : "Zurück" }}
</button>
